<template lang="html">
  <div id="app">
    <div class="container-scroller">
      <app-header/>
      <div class="container-fluid page-body-wrapper">
        <app-sidebar/>
        <div class="main-panel">
            <router-view></router-view>
          <!-- content wrapper ends -->
          <app-footer/>
        </div>
        <!-- main panel ends -->
      </div>
      <!-- page-body-wrapper ends -->
    </div>
  </div>
</template>

<script lang="js">
import AppHeader from '../../../src/components/partials/AppHeader'
import AppSidebar from '../../../src/components/partials/AppSidebar'
import AppFooter from '../../../src/components/partials/AppFooter'
export default{
  name: 'Layout',
  components: {
    AppHeader, AppSidebar, AppFooter
  }
}
</script>

<style>
  @import "../../../node_modules/mdi/css/materialdesignicons.min.css";
  @import "../../../node_modules/flag-icon-css/css/flag-icon.min.css";
  @import "../../../node_modules/font-awesome/css/font-awesome.min.css";
</style>

<style lang="scss">
  @import "./../../assets/scss/style";
</style>



// WEBPACK FOOTER //
// src/components/partials/Layout.vue